<template lang="html">
  <div class="animated fadeIn">

  <b-card-body fluid="xl">
    <b-row class="text-center">
      <b-col cols="12">
          <h2><b-badge variant="info">Readings for {{this.months[this.form.readingMonth.month()]}}/{{this.form.readingMonth.year()}}</b-badge></h2>
      </b-col>
    </b-row>
  </b-card-body>
  <b-card>
    <b-row>
      <b-col lg="6" class="my-1">
        <b-form-group label="Select Month:"  label-for="readingMonth"    label-cols-sm="3"
           label-align-sm="right"
           label-size="sm"
            class="mb-0">
          <vue-monthly-picker v-model="$v.form.readingMonth.$model" id="readingMonth"
                               :monthLabels="this.months" dateFormat="MMMM/YYYY">
          </vue-monthly-picker>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6" class="my-1">
       <b-form-group
         label="Filter by Line"
         label-cols-sm="3"
         label-align-sm="right"
         label-size="sm"
         label-for="lineSelect"
         class="mb-0"
       >
        <b-input-group size="md">
           <b-form-select size="md"  v-model="$v.form.filter.$model" id="lineSelect" :options="filterOptions" >
               <template #first>
                 <b-form-select-option value=''>Please select Line to filter</b-form-select-option>
               </template>
            </b-form-select>
         </b-input-group>
       </b-form-group>
     </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-btn  class="mb-0" type="submit" variant="success" @click="filterReadings" :disabled="$v.form.$invalid">Submit</b-btn>
      </b-col>
    </b-row>
  </b-card>

  <b-card v-if="profiles!=null && Object.keys(profiles).length > 0" >
    <b-row>
      <b-col>
        <b-table hover :busy="isBusy"
           :current-page="currentPage" :per-page="perPage" :items="profiles" :fields="fields" id="dataTable"
           ref="dataTable" responsive="sm">

          <template #table-busy>
             <div class="text-center text-danger my-2">
               <b-spinner class="align-middle"></b-spinner>
               <strong>Loading...</strong>
             </div>
          </template>
          <template v-slot:cell(houseno)="row">
            <b>{{ row.value}}</b>
          </template>
          <template v-slot:cell(isNewMeter)="row">
            <b-form-checkbox
                            :id="`newmeter-${getIndex(row.index)}`"
                            :ref="`newmeter-${getIndex(row.index)}`"
                            :checked="getNewMeterModel(row)"
                            @change="setNewMeterModel($event,row)"
                            switch>

            </b-form-checkbox>
          </template>
          <template v-slot:cell(currentReading)="row">
              <b-form-group label="" label-for="current">
                <b-form-input
                              :id="`current-${getIndex(row.index)}`"
                              :ref="`current-${getIndex(row.index)}`"
                              type="number"
                              :value="getModel(row)"
                              @change="setModel($event,row)"
                              :state="validateState(getIndex(row.index))"
                              :aria-describedby="`liveFeedbackcurrent-${getIndex(row.index)}`"
                              @blur="updateUnitBalace(row)"
                              placeholder="Current Reading" />
                <b-form-invalid-feedback :id="`liveFeedbackcurrent-${getIndex(row.index)}`">
                    This field can only contain numbers and it must be greater than 0.
                </b-form-invalid-feedback>
              </b-form-group>
            </template>
        </b-table>
      </b-col>
    </b-row>
      <b-row v-if="profiles!=null && Object.keys(profiles).length > 0" class="text-center">
        <b-col cols="12" class="my-1">
          <b-pagination
             v-model="currentPage"
             :total-rows="totalRows"
             :per-page="perPage"
             align="fill"
             @page-click="isPageEnabled"
             class="my-0">
         </b-pagination>
        </b-col>
      </b-row>
  </b-card>
  <b-card v-if="profiles!=null && Object.keys(profiles).length > 0">
    <b-row>
      <b-col cols="12">
        <b-button type="submit" @click="submitReadings" variant="primary" :disabled="$v.form.$invalid">
          Save and Next
        </b-button>
      </b-col>
    </b-row>
  </b-card>

  </div>
</template>


<script>
  import Vue from 'vue'
  import VueLodash from 'vue-lodash'
  import map from 'lodash/map'
  import filter from 'lodash/filter'
  import {
    mapState,
    mapActions
  } from 'vuex'
  import moment from 'moment'
  import { validationMixin } from "vuelidate";
  import { required, minValue, decimal } from "vuelidate/lib/validators";
  const formShape = {
    readingMonth: null,
    filter: null,
    profiles: []
  }


  export default {
    name: 'HouseReadings',
    mixins: [validationMixin],

    data: function() {
      return {

        totalRows: 1,
        form: Object.assign({}, formShape),
        submitted: false,
        currentPage: 1,
        submittedPages: [],
        perPage: 50,
        selectedProfile: null,
        fields: [
                    {key:'name', label:'Satsangi Name'},{key:'houseno', label:'House No'},
                    {key:'isNewMeter', label:'New Meter'},
                    {key:'currentReading', label:'Current Reading'},
                    {key:'lastReading', label:'Previous Reading'},
                    {key:'units', label:'Total Units'}, {key:'balance', label:'Current Balance'},

                ],

        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
        isBusy: false,
        months: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],

      }
    },
    computed: {
      filterOptions(){
        return filter(this.$store.state.electrical.electricLines,
           function(line) {
             return line.isEnabled;
           }
         ).map( (line) => {
            return {
              text: line.lineName,
              value: line.id
            }
        });
      },
      profiles(){
        return this.form.profiles;

      },
      isValid() {
        this.$v.$touch();
        return !this.$v.form.$anyError
      },
      getCurrentMonth(){
        return new Date().getMonth();
      },
      getCurrentYear(){
        return new Date().getFullYear();
      }


    },
    validations: {
      form: {
        readingMonth: {
          required
        },
        filter: {
          required
        },
        profiles:{
          $each: {
            currentReading: {
              minValue: minValue(0),
              decimal
            },
            balance: {
              decimal
            },
            units: {
              decimal,
              minValue: minValue(0),

            }
          }
      }
      }
    },
    methods:{
      filterReadings(){
        var readingMonth = moment([this.form.readingMonth.year(), this.form.readingMonth.month(), 26]);
        var currentMonth = moment([moment().year(), moment().month(), 26]);

        if(readingMonth.isAfter(currentMonth)){
            this.showErrorMsg({message: "Reading Month can not be in future."});
            return;
        }

        currentMonth = moment([moment().year(), moment().month(), 26]).subtract(1, 'months');

        if(readingMonth.isBefore(currentMonth)){
          this.showErrorMsg({message: "Only one month in past is allowed for reading."});
          return;
        }
        this.getMonthReadings();
      },
      isPageEnabled(bvEvt, page){
        let submitted = this.submittedPages.some(s =>{
          if(page == s){
            return true;
          }
        });

        if(submitted == true){
          this.showErrorMsg({message: "This page has already been saved."});
          bvEvt.preventDefault();
        }
      },
      getIndex(index){
        return  (this.currentPage -1) * this.perPage + index;
      },
      updateUnitBalace(row){
        let index =  (this.currentPage -1) * this.perPage + row.index;
        if(row.item.currentReading <= 0 && row.item.isNewMeter == false && row.item.lastReading != 0){
          this.showErrorMsg({message: "Reading must be 0 or greater. Please enter valid value."});
          var textRef = 'current-' + index;
          this.$refs[textRef].focus();
          return;
        }
        else if(row.item.currentReading < row.item.lastReading && row.item.isNewMeter == false){
          this.showErrorMsg({message: "Current Reading must be greater or equal to Previous reading when New Meter is not checked. Please enter valid value."});
          var textRef = 'current-' + index;
          this.$refs[textRef].focus();
          return;
        }
        else {
          if(isNaN(parseFloat(row.item.currentReading)) && row.item.isNewMeter == true){
            this.showErrorMsg({message: "Current Reading cannot be empty when New Meter is checked. Please enter valid value."});
            var textRef = 'current-' + index;
            this.$refs[textRef].focus();
            return;
          }
        }

          if(row.item.isNewMeter == true) {
            this.form.profiles[index]['units'] =  row.item.currentReading
          }
          else{
            this.form.profiles[index]['units'] = row.item.currentReading - row.item.lastReading;

          }

            let tempBalance = this.form.profiles[index].chargeTypes.reduce((acc, value) => {
                return acc + value.chargeAmount;
            }, 0);
            tempBalance = tempBalance + (this.form.profiles[index]['units'] * this.form.profiles[index]['chargeAmount'])
            this.form.profiles[index]['balance'] = tempBalance.toFixed(2);




      },
      getModel(row){
        let index =  (this.currentPage -1) * this.perPage + row.index;
        return this.form.profiles[index].currentReading;
      },
      setModel(value, row){
        let index =  (this.currentPage -1) * this.perPage + row.index;
        this.form.profiles[index]['currentReading'] = value;
      },
      getNewMeterModel(row){

        let index =  (this.currentPage -1) * this.perPage + row.index;

        return this.form.profiles[index]['isNewMeter'];
      },
      setNewMeterModel(value, row){
        let index =  (this.currentPage -1) * this.perPage + row.index;
        var textRef = 'newmeter-' + index;
        if(value == false){
          if(row.item.currentReading <= 0 && row.item.lastReading != 0){
              this.showErrorMsg({message: "Reading must be 0 or greater. Please enter valid value."});
              let checkRef = 'newmeter-' + index;
              this.$refs[checkRef].localChecked = true;
              let textRef = 'current-' + index;
              this.$refs[textRef].focus();
              this.form.profiles[index]['isNewMeter'] = false;
              return;
          }
          else if(row.item.currentReading < row.item.lastReading){
            this.showErrorMsg({message: "Current Reading must be greater or equal to Previous reading when New Meter is not checked. Please enter valid value."});
            let checkRef = 'newmeter-' + index;
            this.$refs[checkRef].localChecked = true;
            let textRef = 'current-' + index;
            this.$refs[textRef].focus();
            this.form.profiles[index]['isNewMeter'] = false;
            return;
          }
        }
         this.form.profiles[index]['isNewMeter'] = value;
          var textRef = 'newmeter-' + index;
          this.$refs[textRef].localChecked = value;
        },

      validateState(index) {
        const { $dirty, $error } = this.$v.form.profiles.$each[index].currentReading;
        return $dirty ? !$error : null;
      },
      getMonthReadings(){
              this.form.profiles = null;
              this.isBusy = true;
              this.$nextTick(() => {
                this.$store.dispatch('electrical/getReadings', {readingMonth: this.form.readingMonth.month() + 1,readingYear: this.form.readingMonth.year(), line: this.form.filter})
                  .then((response) => {
                    if(response.data.success == false){
                        this.showErrorMsg({
                          message: response.data.error
                        });
                    }
                    else{
                        if(response.data.data == null || response.data.data.length == 0){
                            this.showErrorMsg({message: "All readings are up to date for selected month and line."})
                        }
                        else{
                          response.data.data.forEach(reading => {
                            reading['isNewMeter'] = false;
                            reading['balance'] = "";
                            reading['units'] = "";
                          })
                          this.form.profiles = response.data.data;
                          this.totalRows = this.form.profiles.length;
                          this.submittedPages.length = 0;
                          this.currentPage = 1;
                          this.isBusy = false;
                        }



                        //TODO: Move page records to next page.
                      }
                  })
                  .catch((error) => {

                    if (error.response.status == 400) {
                      this.showErrorMsg({
                        message: error.response.data.message
                      })
                    }
                    else if (error.response.status == 422){
                        this.showErrorMsg({
                          message: error.response.data.message
                        });

                    }
                    else {
                      this.showErrorMsg({message: "Something went wrong. Please contact administrator."})
                    }
                    this.isBusy = false;
                  })
              })

      },
      submitReadings() {
          if(this.isValid){
          this.$nextTick(() => {
            let pageItems = this.$refs.dataTable.paginatedItems;
            let exists = pageItems.some(function(value, pos, readings){
              if(value.currentReading <= 0 && value.isNewMeter == false && value.lastReading != 0){
                let index =  (this.currentPage -1) * this.perPage + pos;
                let textRef = 'current-' + index;
                this.$refs[textRef].focus();
                this.showErrorMsg({message: "Reading must be 0 or greater. Please enter valid value."})
                return true;
              }
              else if(value.currentReading < value.lastReading && value.isNewMeter == false){
                this.showErrorMsg({message: "Current Reading must be greater or equal to Previous reading when New Meter is not checked. Please enter valid value."});
                let index =  (this.currentPage -1) * this.perPage + pos;
                let textRef = 'current-' + index;
                this.$refs[textRef].focus();
                this.form.profiles[index]['isNewMeter'] = false;
                return true;
              }
              else {
                let index =  (this.currentPage -1) * this.perPage + pos;
                if(isNaN(parseFloat(value.currentReading)) && value.isNewMeter == true){
                  this.showErrorMsg({message: "Current Reading cannot be empty when New Meter is checked. Please enter valid value."});
                  var textRef = 'current-' + index;
                  this.$refs[textRef].focus();
                  return;
                }
              }

            }, this);

            if(exists == true){
              return;
            }

            let parameters = {readingMonth: {month: this.form.readingMonth.month() + 1, year: this.form.readingMonth.year(), line: this.form.filter},
                        readings: map(pageItems, (value, key) => {
                                            return {
                                              nonfixed: {units: value.units, id: value.id,
                                                         reading: value.currentReading,
                                                         newMeter: value.isNewMeter,
                                                         lastReading: value.lastReading
                                                        },
                                              fixed: value.chargeTypes
                                            }
                                          })
                              }


            this.$store.dispatch('electrical/addReadings', parameters)
              .then((response) => {
                if(response.data.success == false){
                    this.showErrorMsg({
                      message: response.data.error
                    });
                }
                else{
                    this.showSuccessMsg({
                      message: 'Records saved successfully.'
                    });
                    this.submittedPages.push(this.currentPage);
                    this.currentPage = this.currentPage + 1;

                  }


              })
              .catch((error) => {

                if (error.response.status == 400) {
                  this.showErrorMsg({
                    message: error.response.data.message
                  })
                }
                else if (error.response.status == 422){
                    this.showErrorMsg({
                      message: error.response.data.message
                    });

                }
                else {
                  this.showErrorMsg({message: "Something went wrong. Please contact administrator."})
                }
              })

          })
        }
      },
      onReset() {
        this.form = formShape
        this.$nextTick(() => {
          this.$v.$reset()
        })
      },


    },
    beforeMount() {

    },
    mounted() {

    },
    created(){
      if (this.$store.state.electrical.electricLines.length == 0) {
        this.$store.dispatch('electrical/getElectricLines');
      }
      this.form.readingMonth = moment();

    }

  }
</script>

<style lang="css">
.ag-row-hover {
/* putting in !important so it overrides the theme's styling as it hovers the row also */
background-color: #dfdfff !important;
}

.ag-column-hover {
background-color: #dfffdf;
}
</style>
